"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationResultsToJSON = exports.RecommendationResultsFromJSONTyped = exports.RecommendationResultsFromJSON = exports.instanceOfRecommendationResults = void 0;
var runtime_1 = require("../runtime");
var Budget_1 = require("./Budget");
/**
 * Check if a given object implements the RecommendationResults interface.
 */
function instanceOfRecommendationResults(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfRecommendationResults = instanceOfRecommendationResults;
function RecommendationResultsFromJSON(json) {
    return RecommendationResultsFromJSONTyped(json, false);
}
exports.RecommendationResultsFromJSON = RecommendationResultsFromJSON;
function RecommendationResultsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'showRecommendation': !(0, runtime_1.exists)(json, 'show_recommendation') ? undefined : json['show_recommendation'],
        'billableEvents': !(0, runtime_1.exists)(json, 'billable_events') ? undefined : json['billable_events'],
        'uniqueUsers': !(0, runtime_1.exists)(json, 'unique_users') ? undefined : json['unique_users'],
        'budget': !(0, runtime_1.exists)(json, 'budget') ? undefined : (0, Budget_1.BudgetFromJSON)(json['budget']),
    };
}
exports.RecommendationResultsFromJSONTyped = RecommendationResultsFromJSONTyped;
function RecommendationResultsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'show_recommendation': value.showRecommendation,
        'billable_events': value.billableEvents,
        'unique_users': value.uniqueUsers,
        'budget': (0, Budget_1.BudgetToJSON)(value.budget),
    };
}
exports.RecommendationResultsToJSON = RecommendationResultsToJSON;
